import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { stringifyQueryString } from '@/Utils/FnUtils';
import { apiClient } from '@/_config/lib/axios/api-client';

interface PutArrivalAtClientParams {
  deliveryId: string;
  deliverymanId: string;
}

const putArrivalAtClient = ({
  deliveryId,
  deliverymanId,
}: PutArrivalAtClientParams) => {
  return apiClient
    .put(
      `/jackson/v2/${deliverymanId}/chegou-no-cliente/?${stringifyQueryString({
        deliveryId,
      })}`,
    )
    .then(response => {
      handleResponseSuccess(response, 'Operação realizada com sucesso')();
    })
    .catch(handleResponseThrowError());
};

const usePutArrivalAtClient = () => {
  return useMutation({ mutationFn: putArrivalAtClient });
};

export { usePutArrivalAtClient };
